module.exports = __webpack_public_path__ + "static/media/block-2_8_1.6a31188e.svg";